import { Injectable } from "@angular/core";
import { AbstractClass, TableCell } from "@classes/abstract.class";
import { WorkScheduleType } from '@models/work-schedule-type';

@Injectable({providedIn: 'root'})
export class WorkScheduleTypeClass extends AbstractClass {
  model: WorkScheduleType;
  modelName = 'WorkScheduleType';
  idName = 'workScheduleTypeID';
  langBase = 'cms.components.work-schedule-type.';
  route = 'admin/es/settings/work-schedule-type';
  tableCells: TableCell[] = [
    { name: 'type', label: 'type', cellType: 'text', order: true, download: true },
    { name: 'isActive', label: 'status', cellType: 'active-text', order: true, download: true },
    { name: 'createdAt', label: 'createdAt', cellType: 'date', order: true, download: true },
    //{ name: 'siteLocation.city.countryZone.zoneName', label: 'countryZone', cellType: 'text', order: true },
    //{ name: 'siteLocation.city.cityName', label: 'city', cellType: 'text', order: true },
  ];
  formAccordion = [];
  formTabs = [];
  formCells = [
    // { name: 'name', label: 'name', cellType: 'text', disable: false, order: 1, cols: 'col-12 col-md-6', required: true, multiple: false },
    { name: 'type', label: 'type', cellType: 'text', disable: false, order: 1, cols: 'col-12 col-md-6', required: true, multiple: false, type: 'string' },
    { name: 'isActive', label: 'isActive', cellType: 'checkbox', disable: false, order: 6, cols: 'col-12 col-md-6', required: false, multiple: false, type: 'boolean' }
  ];
  modelCells = [];
  tabs = [];

  constructor()
  {
    super();
    this.stringsToRemove = ['createdAt'];
    this.model = {
      workScheduleTypeID: 0,
      type: '',
      isActive: true,
      createdBy: '',
      createdAt: new Date(),
      updatedAt: new Date()
    };
  }
}
